export const locales = ['es', 'en'] as const; // Supported locales
export type AppLocale = (typeof locales)[number]; // Type for supported locales
export const defaultLocale = 'es'; // Default locale

export type LanguageMap<ValueType = string> = Record<AppLocale, ValueType>;

export const i18nNamespaces = ['shared', 'home', 'cms', 'newsletter', 'contact', 'legal'];

export function parseLocale(locale: unknown): AppLocale {
  for (const item of locales) {
    if (item === locale) {
      return item;
    }
  }
  return defaultLocale;
}

export function createLocaleMap<ValueType = string>(defaultValue: ValueType) {
  return {
    es: defaultValue,
    en: defaultValue
  } satisfies LanguageMap<ValueType>;
}

export function mapLocaleMap<OldValueType = string, NewValueType = string>(
  map: LanguageMap<OldValueType>,
  fn: (value: OldValueType) => NewValueType
): LanguageMap<NewValueType> {
  const newMap = createLocaleMap<NewValueType>('' as NewValueType);

  locales.forEach((lang) => {
    newMap[lang] = fn(map[lang]);
  });

  return newMap;
}

export function getPathnameWithLocale<T extends string>(language: AppLocale, pathname: T) {
  const parsePathname = (
    !pathname.startsWith('/') ? `/${pathname}` : pathname
  ) as T extends `/${string}` ? T : `/${T}`;
  if (language === defaultLocale) return parsePathname;
  return `/${language}${parsePathname}` as const;
}

export function getLocaleFromPathname(pathname: string): AppLocale | null {
  for (const language of locales) {
    if (pathname.startsWith(`/${language}`)) {
      return language;
    }
  }
  return null;
}
